import { observable, makeObservable } from "mobx";

class ConfirmStore {
    titulo: string;
    corpo: string | any;
    modalAberto = false;
    acaoUnica: boolean = false;
    resolve: (value?: any) => void;

    constructor() {
        makeObservable(this, {
            titulo: observable,
            corpo: observable,
            modalAberto: observable,
            acaoUnica: observable
        });
    }
}

export default new ConfirmStore();